// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { formatDueDate } from '@tectonics/prs/nequi';
import type { PendingIncomingPayment } from '@tectonics/prs/incoming-payment';

export function TicketDue(): Node {
  const expirationDateTime = getExpirationDueDatetime(usePendingIncomingPayment());

  return (
    <Root>
      <Term>Pay until </Term>
      <Definition>{formatDueDate(expirationDateTime)}</Definition>
    </Root>
  );
}

export function getExpirationDueDatetime(incomingPayment: PendingIncomingPayment): string {
  const expirationDueDatetime = incomingPayment['upi']['expiration_date'];

  if(!expirationDueDatetime){
    throw new Error('Upi QrCode: the upi expiration_date field must be informed in incoming payment');
  }

  return expirationDueDatetime;
}

const Root = styled.dl`
  text-align: center;
  padding: 1.2em;
`;

const Term = styled.dt`
  font-family: ${props => props.theme.fontFamily.sansSerif};
  font-size: 0.9em;
`;

const Definition = styled.dd`
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.3em;
  font-weight: bold;
`;
